import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AddNewCodeRiskAdjusting,
  AddNewCodeSearchParameters,
  AlternateCodeLegacyRiskAdjusting,
  AlternateCodeRiskAdjusting,
  AlternateCodeSearchParameters,
  CodeSystem,
  Icd10SearchBody,
  Icd10SearchParameters,
  transformIcd10Response,
} from '@arcadia/workflow-shared-risk';
import { map, Observable } from 'rxjs';

import { IIcd10CodeSearchResultRecord, SearchBody } from '@assess/shared/data-mart-search';

import { Icd10CodeSearchConfiguration } from '../icd10-code-search-configuration';

@Injectable({ providedIn: 'root' })
export class Icd10CodeSearchService {
  defaultDate = new Date(new Date().getFullYear(), 0, 1).toISOString();

  constructor(
    private readonly http: HttpClient,
    private readonly config: Icd10CodeSearchConfiguration
  ) {}

  search(query: SearchBody<Icd10SearchParameters>): Observable<IIcd10CodeSearchResultRecord[]> {
    const body: Icd10SearchBody = {
      query: query.query ?? '',
      searchParameters: query.filters ?? {
        addNewCode: {
          isUseCaseAll: true,
          date: this.defaultDate,
        },
      },
    };

    const lookup = this.isUseCaseRiskAdjusting(body.searchParameters) ? 'icd10-lookup' : 'any-icd10-lookup';
    const url = `${this.config.rootUrl}/codeservice/search/${lookup}`;

    return this.http.post(url, body).pipe(
      map((result) =>
        transformIcd10Response(result).map(
          (transformedResult): IIcd10CodeSearchResultRecord => ({
            Code: transformedResult.code,
            Description: transformedResult.description,
            CodeType: CodeSystem.ICD10,
          })
        )
      )
    );
  }

  private isUseCaseRiskAdjusting(searchParameters: Icd10SearchParameters) {
    const altCodeParams = searchParameters as AlternateCodeSearchParameters;
    const altCodeRiskAdj = altCodeParams.alternateCode as AlternateCodeRiskAdjusting;
    const altCodeRiskAdjLegacy = altCodeParams.alternateCode as AlternateCodeLegacyRiskAdjusting;

    const addNewParams = searchParameters as AddNewCodeSearchParameters;
    const addNewRiskAdj = addNewParams.addNewCode as AddNewCodeRiskAdjusting;

    return (
      altCodeRiskAdj?.isUseCaseRiskAdjusting ||
      altCodeRiskAdjLegacy?.isUseCaseLegacyRiskAdjusting ||
      addNewRiskAdj?.isUseCaseRiskAdjusting
    );
  }
}
